<div class="p-6 max-w-3xl mx-auto">

  <!-- Header -->
  <div class="mb-5">
    <nav class="flex items-center gap-1.5 text-xs text-gray-400 mb-2">
      <a routerLink="/automation/workflows" class="hover:text-blue-600">Workflows</a>
      <span>/</span>
      <a routerLink="/automation/workflow-actions/test" class="hover:text-blue-600">Probar Acciones</a>
      <span>/</span>
      <span class="text-gray-600">Pipeline RF-09</span>
    </nav>
    <div class="flex items-center gap-2 mb-1">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">Probar Acciones de Pipeline</h1>
      <span class="px-2 py-0.5 text-xs bg-orange-100 text-orange-700 rounded-full font-medium">RF-09</span>
    </div>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      Prueba cambios de etapa, actualización de fecha de cierre y cambio de pipeline sin ejecutar un workflow completo.
    </p>
  </div>

  <!-- Aviso pipeline lógico -->
  <div class="mb-4 p-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg text-xs text-amber-700 dark:text-amber-300">
    <p class="font-semibold mb-1">Limitación actual del CRM</p>
    <p>
      El CRM aún no tiene módulo de pipelines reales (tablas <code>pipeline</code> / <code>deal_stage</code>).
      "Cambiar etapa del negocio" actúa sobre el ciclo del negocio (<code>deal_cycle</code>).
      "Cambiar pipeline / ciclo de negocio" opera en modo compatibilidad usando un pipeline lógico único (ID&nbsp;1).
    </p>
  </div>

  @if (error) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex justify-between text-sm">
      <span>{{ error }}</span>
      <button (click)="error = ''" class="ml-2 shrink-0">&times;</button>
    </div>
  }

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">

    <!-- Formulario -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Configuración</h2>
      <div class="space-y-3">

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de acción *</label>
          <select [(ngModel)]="actionType" (ngModelChange)="onActionTypeChange()"
                  class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500">
            @for (opt of actionTypeOptions; track opt.value) {
              <option [value]="opt.value" [disabled]="opt.disabled">{{ opt.label }}</option>
            }
          </select>
          @if (isTicketAction) {
            <p class="text-xs text-gray-500 mt-1">
              El ticket se indica abajo; el registro de arriba sigue siendo el del workflow.
            </p>
          }
        </div>

        <div class="grid grid-cols-2 gap-2">
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de objeto</label>
            <select [(ngModel)]="objectType" (ngModelChange)="onObjectTypeChange()"
                    class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500">
              @for (ot of objectTypeOptions; track ot.value) { <option [value]="ot.value">{{ ot.label }}</option> }
            </select>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Registro (opcional)</label>
            @if (recordSelect.isSearchable()) {
              <app-entity-select
                [value]="objectId"
                (valueChange)="objectId = $event"
                (selected)="onRecordSelected($event)"
                [displayText]="recordDisplayText"
                [searchFn]="recordSelect.search" [labelFn]="recordSelect.label" [sublabelFn]="recordSelect.sublabel"
                placeholder="Buscar por nombre…"></app-entity-select>
            } @else {
              <input type="number" [(ngModel)]="objectId" placeholder="Ej: 42"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"/>
            }
          </div>
        </div>

        <!-- CHANGE_DEAL_STAGE -->
        @if (isChangeDealStage) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Etapa destino *</label>
            <select [(ngModel)]="targetStageId"
                    class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500">
              <option [ngValue]="null" disabled>Seleccionar etapa…</option>
              @for (c of dealCycles; track c.id) { <option [ngValue]="c.id">{{ c.name }}</option> }
            </select>
          </div>
        }

        <!-- UPDATE_DEAL_CLOSE_DATE -->
        @if (isUpdateCloseDate) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Modo de fecha</label>
            <select [(ngModel)]="closeDateMode"
                    class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500">
              <option value="RELATIVE">Relativa (desde hoy)</option>
              <option value="ABSOLUTE">Fecha exacta</option>
            </select>
          </div>
          @if (closeDateMode === 'RELATIVE') {
            <div class="grid grid-cols-2 gap-2">
              <div>
                <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Cantidad</label>
                <input type="number" [(ngModel)]="closeDateAmount" min="1"
                       class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"/>
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Unidad</label>
                <select [(ngModel)]="closeDateUnit"
                        class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500">
                  <option value="DAYS">Días</option>
                  <option value="WEEKS">Semanas</option>
                  <option value="MONTHS">Meses</option>
                </select>
              </div>
            </div>
          } @else {
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Fecha de cierre</label>
              <input type="date" [(ngModel)]="closeDateAbsolute"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"/>
            </div>
          }
        }

        <!-- CHANGE_PIPELINE -->
        @if (isChangePipeline) {
          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Pipeline destino (ID)</label>
              <input type="number" [(ngModel)]="targetPipelineId" min="1"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"/>
              <p class="text-[10px] text-gray-400 mt-0.5">Pipeline lógico único (ID 1) en modo compatibilidad.</p>
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Etapa destino</label>
              <select [(ngModel)]="targetStageId"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500">
                <option [ngValue]="null">Mantener si es posible</option>
                @for (c of dealCycles; track c.id) { <option [ngValue]="c.id">{{ c.name }}</option> }
              </select>
            </div>
          </div>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="preserveStage" class="w-4 h-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Preservar etapa si es posible</span>
          </label>
        }

        @if (isTicketAction) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Número de ticket</label>
            <input type="text" [(ngModel)]="ticketNumber" placeholder="TKT-1-000123"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"/>
          </div>
          @if (actionType === 'CHANGE_TICKET_STATUS') {
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Estado destino</label>
              <input type="text" [(ngModel)]="ticketStatusName" placeholder="Ej: Resuelto"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"/>
            </div>
          }
          @if (actionType === 'CHANGE_TICKET_PRIORITY') {
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Prioridad destino</label>
              <input type="text" [(ngModel)]="ticketPriorityName" placeholder="Ej: Alta"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"/>
            </div>
          }
          @if (actionType === 'CHANGE_TICKET_PIPELINE') {
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Pipeline destino</label>
              <input type="text" [(ngModel)]="ticketPipelineName" placeholder="Ej: Soporte técnico"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"/>
            </div>
          }
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="continueOnError" class="w-4 h-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si ocurre un error</span>
          </label>
        }

        <!-- Comunes -->
        @if (!isTicketAction) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Motivo (opcional)</label>
            <input type="text" [(ngModel)]="reason" placeholder="Ej: Avance automático por workflow"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-orange-500"/>
          </div>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="continueOnError" class="w-4 h-4 rounded border-gray-300 text-orange-600 focus:ring-orange-500"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Continuar si ocurre un error</span>
          </label>
        }

        <button (click)="test()" [disabled]="loading"
                class="w-full py-2 text-sm rounded-lg disabled:opacity-50 transition-colors inline-flex items-center justify-center gap-2 bg-orange-600 text-white hover:bg-orange-700">
          @if (loading) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
            Ejecutando...
          } @else {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3l14 9-14 9V3z"/>
            </svg>
            Probar acción
          }
        </button>
      </div>
    </div>

    <!-- Resultado -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Resultado</h2>

      @if (!result && !loading) {
        <div class="flex flex-col items-center justify-center py-10 text-gray-300 dark:text-gray-600">
          <svg class="w-10 h-10 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
          </svg>
          <p class="text-sm">Ejecuta una acción de pipeline para ver el resultado</p>
        </div>
      }

      @if (loading) {
        <div class="flex flex-col items-center justify-center py-10 text-gray-400">
          <svg class="animate-spin w-8 h-8 mb-3" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
          </svg>
          <p class="text-sm">Ejecutando acción de pipeline...</p>
        </div>
      }

      @if (result && !loading) {
        <!-- Status badge -->
        <div class="flex items-center gap-3 mb-4 p-3 rounded-lg"
             [ngClass]="result.status === 'SUCCESS' ? 'bg-green-50 dark:bg-green-900/20' : result.status === 'SKIPPED' ? 'bg-gray-50 dark:bg-gray-700/40' : 'bg-red-50 dark:bg-red-900/20'">
          <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold" [ngClass]="getStatusClass(result.status)">
            {{ statusLabel(result.status) }}
          </span>
          <p class="text-sm text-gray-700 dark:text-gray-300">{{ result.message }}</p>
        </div>

        <!-- Key details -->
        <dl class="space-y-1 text-sm mb-4">
          @if (result.actionType) {
            <div class="flex justify-between py-1 border-b border-gray-100 dark:border-gray-700">
              <dt class="text-xs text-gray-500">Tipo de acción</dt>
              <dd class="text-xs font-medium text-gray-900 dark:text-white">{{ actionTypeLabel(result.actionType) }}</dd>
            </div>
          }
          @if (result.targetObjectType) {
            <div class="flex justify-between py-1 border-b border-gray-100 dark:border-gray-700">
              <dt class="text-xs text-gray-500">Objeto afectado</dt>
              <dd class="text-xs font-medium text-gray-900 dark:text-white" [title]="result.targetObjectType || ''">
                {{ recordText(result.targetObjectType, result.targetObjectId) }}
              </dd>
            </div>
          }
        </dl>

        <!-- CHANGE_DEAL_STAGE details -->
        @if (isChangeDealStage && result.output && result.status === 'SUCCESS') {
          <div class="mb-3 p-3 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg text-xs space-y-1">
            <p class="font-semibold text-orange-700 dark:text-orange-400">Negocio actualizado</p>
            @if (result.output['dealId']) {
              <p class="text-orange-600">Negocio: <span class="font-mono font-medium">#{{ result.output['dealId'] }}</span></p>
            }
            @if (result.output['oldStageId'] !== undefined) {
              <p class="text-orange-600">Etapa anterior: <span class="font-medium" [title]="'id ' + result.output['oldStageId']">{{ stageName(result.output['oldStageId']) }}</span></p>
            }
            @if (result.output['newStageId'] !== undefined) {
              <p class="text-orange-600">Etapa nueva: <span class="font-medium" [title]="'id ' + result.output['newStageId']">{{ stageName(result.output['newStageId']) }}</span></p>
            }
            @if (result.output['oldPipelineId'] !== undefined) {
              <p class="text-orange-600">Pipeline anterior: <span class="font-mono">{{ result.output['oldPipelineId'] }}</span></p>
            }
            @if (result.output['newPipelineId'] !== undefined) {
              <p class="text-orange-600">Pipeline nuevo: <span class="font-mono">{{ result.output['newPipelineId'] }}</span></p>
            }
          </div>
        }

        <!-- UPDATE_DEAL_CLOSE_DATE details -->
        @if (isUpdateCloseDate && result.output && result.status === 'SUCCESS') {
          <div class="mb-3 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg text-xs space-y-1">
            <p class="font-semibold text-blue-700 dark:text-blue-400">Fecha de cierre actualizada</p>
            @if (result.output['oldCloseDate']) {
              <p class="text-blue-600">Fecha anterior: <span class="font-mono">{{ result.output['oldCloseDate'] }}</span></p>
            }
            @if (result.output['newCloseDate']) {
              <p class="text-blue-600">Fecha nueva: <span class="font-mono font-medium">{{ result.output['newCloseDate'] }}</span></p>
            }
          </div>
        }

        <!-- CHANGE_PIPELINE details -->
        @if (isChangePipeline && result.output && result.status === 'SUCCESS') {
          <div class="mb-3 p-3 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg text-xs space-y-1">
            <p class="font-semibold text-indigo-700 dark:text-indigo-400">Pipeline / ciclo actualizado</p>
            @if (result.output['oldPipelineId'] !== undefined) {
              <p class="text-indigo-600">Pipeline anterior: <span class="font-mono">{{ result.output['oldPipelineId'] }}</span></p>
            }
            @if (result.output['newPipelineId'] !== undefined) {
              <p class="text-indigo-600">Pipeline nuevo: <span class="font-mono font-medium">{{ result.output['newPipelineId'] }}</span></p>
            }
            @if (result.output['oldStageId'] !== undefined) {
              <p class="text-indigo-600">Etapa anterior: <span class="font-medium" [title]="'id ' + result.output['oldStageId']">{{ stageName(result.output['oldStageId']) }}</span></p>
            }
            @if (result.output['newStageId'] !== undefined) {
              <p class="text-indigo-600">Etapa nueva: <span class="font-medium" [title]="'id ' + result.output['newStageId']">{{ stageName(result.output['newStageId']) }}</span></p>
            }
            @if (result.output['compatibilityMode']) {
              <p class="text-amber-600 font-medium">⚠ Modo compatibilidad: pipeline lógico único.</p>
            }
          </div>
        }

        <!-- Output JSON -->
        @if (result.output && (result.output | json) !== '{}') {
          <div class="mb-3">
            <p class="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Resultado (JSON)</p>
            <pre class="text-xs font-mono bg-gray-50 dark:bg-gray-700/40 p-3 rounded-lg overflow-x-auto text-gray-800 dark:text-gray-200 max-h-40 whitespace-pre-wrap">{{ resultJson }}</pre>
          </div>
        }

        <!-- Error JSON -->
        @if (result.error && (result.error | json) !== '{}') {
          <div class="mb-3">
            <p class="text-xs font-semibold text-red-500 uppercase tracking-wide mb-1">Error</p>
            <pre class="text-xs font-mono bg-red-50 dark:bg-red-900/20 p-3 rounded-lg overflow-x-auto text-red-800 dark:text-red-300 max-h-32 whitespace-pre-wrap">{{ errorJson }}</pre>
          </div>
        }

        <!-- Warnings -->
        @if (result.warnings?.length) {
          <div class="p-2 bg-amber-50 border border-amber-200 rounded text-xs text-amber-700">
            @for (w of result.warnings!; track w) { <p>⚠ {{ w }}</p> }
          </div>
        }
      }
    </div>
  </div>

  <!-- Info note -->
  <div class="mt-4 p-3 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg text-xs text-orange-700 dark:text-orange-300">
    <p class="font-semibold mb-1">Acciones disponibles en RF-09 (Pipeline de ventas):</p>
    <div class="flex flex-wrap gap-1.5 mt-1">
      @for (opt of actionTypeOptions; track opt.value) {
        <span class="px-1.5 py-0.5 rounded text-[10px]"
              [ngClass]="opt.disabled ? 'bg-gray-100 dark:bg-gray-700 text-gray-500' : 'bg-orange-100 dark:bg-orange-900/30'">{{ opt.label }}</span>
      }
    </div>
    <p class="mt-2 text-orange-500">"Cambiar pipeline / ciclo de negocio" funciona en modo compatibilidad, con un único pipeline lógico, hasta que existan pipelines reales.</p>
  </div>

  <!-- Navigation links -->
  <div class="mt-4 flex flex-wrap gap-2">
    <a routerLink="/automation/workflow-actions/test"
       class="inline-flex items-center gap-1 px-3 py-1.5 text-xs border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-400 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors">
      Probar Acciones
    </a>
    <a routerLink="/automation/workflow-actions/crm-test"
       class="inline-flex items-center gap-1 px-3 py-1.5 text-xs border border-indigo-200 dark:border-indigo-800 text-indigo-600 dark:text-indigo-400 rounded-lg hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition-colors">
      Acciones CRM (RF-07)
    </a>
    <a routerLink="/automation/workflow-actions/activity-test"
       class="inline-flex items-center gap-1 px-3 py-1.5 text-xs border border-teal-200 dark:border-teal-800 text-teal-600 dark:text-teal-400 rounded-lg hover:bg-teal-50 dark:hover:bg-teal-900/20 transition-colors">
      Actividades (RF-08)
    </a>
  </div>
</div>
